
import { defineComponent } from '@nuxtjs/composition-api';
import PortfolioBanner from '@/components/partials/public-portfolio/PortfolioBanner.vue';
import JobsInquiryStateQuery from '@/apollo/queries/Jobs/JobsInquiryState.query';
import type { JobsInquiry } from '@/types/graphql';
import { JobsInquiryState } from '@/types/graphql';
import { PORTFOLIO_BANNER_WELCOME_TOOLTIP } from '@/components/partials/public-portfolio/constants';

export default defineComponent({
  name: 'PortfolioBannerWelcome',
  components: {
    PortfolioBanner,
  },
  apollo: {
    currentJobsInquiry: {
      query: JobsInquiryStateQuery,
    },
  },
  data(): { currentJobsInquiry: JobsInquiry | null } {
    return {
      currentJobsInquiry: null,
    };
  },
  computed: {
    isVisible(): boolean {
      if (this.$tooltip.isPresent(PORTFOLIO_BANNER_WELCOME_TOOLTIP)) return false;
      if (!this.currentJobsInquiry) return true;

      return this.currentJobsInquiry?.state === JobsInquiryState.Initialized;
    },
    onboardingUrl(): string {
      return `/b2c/?${new URLSearchParams(this.$route.query as {}).toString()}`;
    },
  },
  methods: {
    close() {
      this.$tooltip.close(PORTFOLIO_BANNER_WELCOME_TOOLTIP);
    },
  },
});
